/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News view component
 *
 * @author Evgeniy Naumov
 * @author Alexander Golshtein
 * @version 1.25.1
 * @since 1.25.0
 */

import { FC } from 'react';

import { Alert, Markdown } from '@nexign/scc-ui-kit';
import { useSelector } from 'react-redux';

import { makeSelectPageNewsTranslation } from '@/main/modules/internationalization/intSelectors';
import { KitLoader } from '@/main/modules/kitLoader';

import { NewsViewContainerStyled } from '../styled/NewsViewStyled';
import { INewsItem } from '../types';
import NewsImages from './NewsImages';

interface INewsViewProps {
    item?: INewsItem;
    isLoading?: boolean;
}

const NewsView: FC<INewsViewProps> = ({ item, isLoading }) => {
    const { userNews: translation } = useSelector(makeSelectPageNewsTranslation());

    if (!item)
        return (
            <NewsViewContainerStyled>
                <Alert body={translation.selectNewsMessage} severity="info" />
            </NewsViewContainerStyled>
        );

    return (
        <NewsViewContainerStyled>
            <KitLoader showLoader={!!isLoading}>
                {item.imageLinks && !!item.imageLinks.length && <NewsImages images={item.imageLinks} />}
                {item.content && <Markdown>{item.content}</Markdown>}
            </KitLoader>
        </NewsViewContainerStyled>
    );
};

export default NewsView;
